import { forwardRef, type ReactNode } from 'react';

// Contenedor estándar de una página: ancho completo con p-6. En páginas con
// panel de filtros lateral funciona como la columna de contenido (flex-1).
// Acepta ref para páginas que controlan su scroll. Ver design.md › Página.
const PageLayout = forwardRef<
  HTMLDivElement,
  { children: ReactNode; className?: string }
>(({ children, className = '' }, ref) => (
  <div ref={ref} className={`w-full min-w-0 flex-1 overflow-x-auto p-6 ${className}`}>
    {children}
  </div>
));

PageLayout.displayName = 'PageLayout';

export default PageLayout;
